namespace GeniuzPOS.QRreport {
    export enum skuorplufg {
        sku = 1,
        plu = 2
    }
    Serenity.Decorators.registerEnumType(skuorplufg, 'GeniuzPOS.QRreport.skuorplufg');
}
